import React from "react";
import { ShieldCheck, BadgeCheck, Crosshair, Trophy } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck, label: "Red Seal Certified" },
  { icon: BadgeCheck, label: "100% Satisfaction Guarantee" },
  { icon: Crosshair, label: "Dealership-Level Precision" },
  { icon: Trophy, label: "Ottawa's #1 Rated Shop" },
];

export default function TrustBadges() {
  return (
    <section
      data-testid="trust-badges"
      className="py-16 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {BADGES.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={b.label}
                data-testid={`trust-badge-${i}`}
                className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 p-5 rounded-xl border border-white/8 bg-white/[0.02] hover:border-[#F5C518]/40 hover:bg-white/[0.04] transition-all text-center sm:text-left"
              >
                <div className="w-11 h-11 shrink-0 rounded-lg bg-[#F5C518]/10 border border-[#F5C518]/30 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-[#F5C518]" strokeWidth={2} />
                </div>
                <span className="font-display font-bold text-sm uppercase tracking-tight leading-tight">
                  {b.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
